import React, { Fragment } from 'react';
import { Intro, PersonalityQuiz, Voiceover } from 'abbot-core';
import img1 from '../../assets/images/U1-T2-1-2a.svg';
import img2 from '../../assets/images/U1-T2-1-2b.svg';
import img3 from '../../assets/images/U1-T2-1-2c.svg';
import img4 from '../../assets/images/U1-T2-1-2d.svg';
import voAudio from '../../assets/vo/U1-T2-1-2.mp3';

const data = {
  answerThreshold: 3,
  questions: [
    {
      question: 'Imagine you’re eating lunch in your school cafeteria. Which of the following is the most nutritious choice?',
      options: [
        {
          label: 'Peanut butter and jelly sandwich on whole grain bread'
        },
        {
          label: 'Ham and cheese sandwich'
        },
        {
          label: 'Choose not to eat'
        }
      ],
      image: img1,
      imageText: ''
    },
    {
      question: 'Which of the following is the most nutritious fruit choice?',
      options: [
        {
          label: 'A small bowl of apple slices'
        },
        {
          label: 'A package of fruit snacks made with real strawberries.'
        },
        {
          label: 'A cup of 100% apple juice with no added sugar'
        }
      ],
      image: img2,
      imageText: ''
    },
    {
      question: 'Which is the most nutritious drink choice?',
      options: [
        {
          label: 'Water'
        },
        {
          label: 'Diet soda'
        },
        {
          label: 'Fruit juice'
        }
      ],
      image: img3,
      imageText: ''
    },
    {
      question: 'Which of the following is the most nutritious dinner choice?',
      options: [
        {
          label: 'A Vegetable and Bean Burrito'
        },
        {
          label: 'Cheeseburger with Fries'
        },
        {
          label: 'Cheesy Ranch Vegetable Casserole'
        }
      ],
      image: img4,
      imageText: ''
    },
  
  ]
};

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <p>
      But first let’s figure out if you know how to make the most nutritious food choice possible. Take this quick quiz to find out.
    </p>
  )
};

const feedback = [
  {
    title: 'You Make Nutritious Food Choices',
    body: 'You are pretty good at making the most nutritious food choices possible. You’ll learn more about what you should consider when choosing what to eat and why it’s so important in the module.'
  },
  {
    title: 'Developing Nutritious Food Choices',
    body: 'You might consider adding more nutritious foods into your daily diet. You’ll learn more about what you should consider when choosing what to eat and why it’s so important in the module.'
  },
  {
    title: 'Nutritious Food Choices Can Be Tricky',
    body: 'Sometimes you might think that choosing not to eat at all is healthier than eating something that might be unhealthy or that if something has fruits or vegetables in it, it is automatically healthy. That isn’t always the case. You’ll learn more about what you should consider when choosing what to eat and why it’s so important in the module.'
  },
  {
    title: 'Need Help Making Nutritious Food Choices?',
    body: 'You’ll learn more about what you should consider when choosing what to eat and why it’s so important in the module.'
  }
];

export default {
  title: 'Making Nutritious Food Choices',
  path: '/prepare/making-nutritious-food-choices',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      
      <Intro
        title="Do you know how to make the most nutritious food choice possible?"
        lead="Take this quiz to find out."
        direction="Select the best answer for each question."
      />
      
      <PersonalityQuiz
        data={data}
        feedback={feedback}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/prepare/MakingNutritiousFoodChoices.js